module.exports = __webpack_public_path__ + "static/media/Load_Out_Loop_Temperature.d1275d9a.svg";